import {Room, SapiAbstractOfferType, SplitBooking} from '../../types/room'

/**
 * Maps a room object to an abstract offer format
 * @param room - Room object containing room details and offers
 * @returns Abstract offer object with room data and metadata
 */
export const mapRoomToAbstract = (room: Room) => ({
  id: room.id,
  type: SapiAbstractOfferType.Regular,
  data: room
})

/**
 * Maps SB object to an abstract offer format
 * @param splitBooking - SB object
 * @returns Abstract offer object with room data and metadata
 */
export const mapSplitBookingToAbstract = (splitBooking: SplitBooking) => ({
  id: splitBooking.bundleId,
  type: SapiAbstractOfferType.SplitBooking,
  data: splitBooking
})
